var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v("Edit Mover")]),
    _vm._v(" "),
    _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col" }, [
        _vm.mover.status_id === 2
          ? _c(
              "button",
              {
                staticClass: "btn btn-danger pull-right",
                on: {
                  click: function($event) {
                    _vm.changeStatus(3)
                  }
                }
              },
              [_vm._v("\n        Deactivate mover\n      ")]
            )
          : _c(
              "button",
              {
                staticClass: "btn btn-success pull-right",
                on: {
                  click: function($event) {
                    _vm.changeStatus(2)
                  }
                }
              },
              [_vm._v("\n        Activate mover\n      ")]
            )
      ])
    ]),
    _vm._v(" "),
    _c("div", [
      _vm.mover
        ? _c(
            "div",
            { staticClass: "l-bg-white" },
            [
              _c("mover-edit-info", {
                attrs: { mover: _vm.mover },
                on: { updated: _vm.loadMover }
              })
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a55bb19", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a55bb19","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/movers/MoversEdit.vue
// module id = null
// module chunks = 